import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Check, Loader2, XCircle } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        if (attempts++ < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sid]);

  return (
    <div className="min-h-screen bg-[#FFFAF5] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="orb orb-orange" style={{width: 500, height: 500, top: -200, right: -100, opacity: 0.3}}/>
      <div className="relative w-full max-w-lg card-smart p-10 text-center" data-testid="checkout-success">
        {status === "polling" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-[#FF7A29] mx-auto mb-4"/>
            <h1 className="font-display text-3xl">Verifica pagamento…</h1>
            <p className="text-sm text-[#555] mt-2">Attendere, stiamo confermando la transazione.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-20 h-20 bg-[#FF7A29] rounded-full mx-auto mb-6 flex items-center justify-center shadow-xl shadow-orange-300"><Check className="w-10 h-10 text-white" strokeWidth={3}/></div>
            <h1 className="font-display text-4xl">Pagamento confermato</h1>
            <p className="text-sm text-[#555] mt-2">Il tuo piano è stato attivato. Grazie!</p>
            {data && <p className="text-xs text-[#757575] mt-3">€{(data.amount_total/100).toFixed(2)} {data.currency?.toUpperCase()}</p>}
            <Link to="/app"><Button data-testid="back-to-app" className="mt-8 rounded-full bg-[#FF7A29] hover:bg-[#E85D00] h-12 px-8 btn-glow">Vai alla Dashboard</Button></Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle className="w-12 h-12 text-[#E60000] mx-auto mb-4"/>
            <h1 className="font-display text-3xl">Pagamento non confermato</h1>
            <p className="text-sm text-[#555] mt-2">Riprova o contatta il supporto.</p>
            <Link to="/app/billing"><Button className="mt-6 rounded-full bg-[#0A0A0A] hover:bg-[#FF7A29] h-11 px-8">Torna ai piani</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
